var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"value":_vm.range,"items":_vm.quickRanges,"label":_vm.label || _vm.$t('quickRanges.title'),"hide-details":_vm.hideDetails,"disabled":_vm.disabled,"return-object":_vm.returnObject},on:{"input":_vm.updateModel}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }